import { makeStyles } from '@mui/styles';

const inputStyles = makeStyles((theme) => {
  return {
    formControlClass: {
      backgroundColor: '#FFF',
    },
    formControlTextFieldClass: {
      backgroundColor: '#FFF',
    },
    selectRoot: {
      padding: '5px 10px',
      display: 'flex',
      alignItems: 'center',
    },
    selectRootNoPaddingLeft: {
      padding: '5px 0px 5px 0px',
      display: 'flex',
      alignItems: 'center',
    },
    selectInputBase: {
      borderRadius: '4px',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    textFieldRoot: {
      padding: '10px 10px',
    },
    textFieldNoLeftPaddingRoot: {
      padding: '10px 10px 10px 0px',
    },
    listItemIconRoot: {
      minWidth: '0',
      marginRight: '10px',
    },
    backdrop: {
      zIndex: theme.zIndex.drawer - 1,
      color: theme.palette.primary.dark,
    },
  };
});

export default inputStyles;
